/** Shared DataGrid surface styling for x-IAM console pages (dark, high-contrast headers). */
export const enterpriseDataGridSx = {
  border: 'none',
  bgcolor: 'transparent',
  '& .MuiDataGrid-main': {
    borderRadius: 2,
  },
  '& .MuiDataGrid-columnHeaders': {
    bgcolor: 'rgba(8, 14, 26, 0.85)',
    borderBottom: '1px solid rgba(110, 168, 254, 0.22)',
    fontWeight: 700,
    fontSize: 12,
    letterSpacing: 0.4,
    textTransform: 'uppercase',
    color: 'text.secondary',
  },
  '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-cell:focus': {
    outline: 'none',
  },
  '& .MuiDataGrid-cell': {
    borderColor: 'rgba(255,255,255,0.045)',
  },
  '& .MuiDataGrid-row:hover': {
    bgcolor: 'rgba(110, 168, 254, 0.055)',
  },
  '& .MuiDataGrid-row.Mui-selected': {
    bgcolor: 'rgba(110, 168, 254, 0.09)',
  },
  '& .MuiDataGrid-footerContainer': {
    borderTop: '1px solid rgba(255,255,255,0.06)',
    bgcolor: 'rgba(8, 14, 26, 0.4)',
  },
  '& .MuiDataGrid-toolbarContainer': {
    px: 1.5,
    py: 1.25,
    gap: 1,
    borderBottom: '1px solid rgba(255,255,255,0.05)',
  },
} as const;
